import { Box, Text } from '@chakra-ui/react'
import type { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos'
import { formatPersonAddress, formatPersonFullName } from 'BrokerTsLib/src/dtos'
import React from 'react'
import { formatDate } from '../../utils/formatDate'
import { InsuranceInfoItem } from './InsuranceInfoItem'


export const InsuranceInfoDetailsTravel = (data: InsuranceParamsTravelDto) => {
  const fullname = formatPersonFullName(data?.policyHolder?.person)
  const address = formatPersonAddress(data?.policyHolder?.person.address)


  return (
    <>
      {data.travel.insuranceEndDate &&
                <InsuranceInfoItem
                  label="Konec pojištění"
                  value={formatDate({ date: new Date(data.travel.insuranceEndDate!) })} />}

      <Box sx={{ gridArea: 'details', fontSize: 'sm' }}>
        {fullname.length > 0 && <Text sx={{ fontWeight: 'medium' }}>{fullname}</Text>}
        {address.length > 0 && <Text sx={{ fontWeight: 'medium' }}>{address}</Text>}
        {data.travel.destinationDescription && <Text sx={{ fontWeight: 'medium' }}>{data.travel.destinationDescription}</Text>}
      </Box>
    </>
  )
}
